import Image, { ImageProps } from 'next/image';

interface OptimizedImage extends ImageProps {
  disableAuto?: boolean;
  showBlur?: boolean;
}

function OptimizedImage(props: OptimizedImage) {
  return (
    <Image
      src={props?.src || '/images/commons/404.webp'}
      alt={props.alt || 'alt'}
      width={props.width || 70}
      height={props.height || 70}
      key={props.src + 'key'}
      className={`${props.disableAuto ? '' : 'h-auto'} ${props.className ?? ''}`}
      style={props.style}
      priority
      onClick={props?.onClick}
      unoptimized={(props?.src as string)?.includes('gif')}
    />
  )
}
export default OptimizedImage
